import { Card, CardBody, Col, Form } from 'reactstrap'
import { MultipleSectionWithHeader } from '../../../../../Utils/Constants'
import { Typeahead } from 'react-bootstrap-typeahead'
import CardHeaderCommon from '../../../../../Utils/CommonComponents/CardHeaderCommon'
import { multiWithHeaderData, multipleSectionHeaderData } from '../../../../../Data/Forms/FormsWidgets/Typeahead/Typeahead'

const MultipleSectionsWithHeaders = () => {
  return (
    <Col sm="12" md="6">
      <Card>
        <CardHeaderCommon  title={MultipleSectionWithHeader} span={multipleSectionHeaderData}/>
        <CardBody>
          <div id="multiple-datasets">
            <Form className="theme-form">
              <div>
                <Typeahead  options={multiWithHeaderData} multiple clearButton placeholder="NBA and NHL teams" labelKey="name" id="1" />
              </div>
            </Form>
          </div>
        </CardBody>
      </Card>
    </Col>
  )
}

export default MultipleSectionsWithHeaders